import { getCurrentInstance } from 'vue';

export const useLocale = () => {
  const instance = getCurrentInstance()?.proxy;

  const t = (key: string, ...params: unknown[]): string =>
    // @ts-ignore
    instance.$t(key, ...params);
  const n = (value: number): string =>
    // @ts-ignore
    instance.$n(value);

  const locale = () =>
    // @ts-ignore
    instance.$i18n.locale as string;

  return { t, n, locale };
};
